module.exports = __webpack_public_path__ + "static/media/more_media.bc5ba5ff.svg";